import { Box, Button, Flex, Image, Link, Stack, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import logo from "../images/logo2.png";

export default function Welcome() {
  return (
    <Flex
      flexDirection="column"
      width="100wh"
      minH="100vh"
      backgroundColor="gray.200"
      justifyContent="center"
      alignItems="center"
      px={4}
    >
      <Stack spacing={6} align="center" maxW="md" textAlign="center">
        <Flex align="center" gap={3} justify="center">
          <Image src={logo} boxSize="72px" alt="" />
          <Text fontSize="4xl" fontWeight="bold">
            WorryLess
          </Text>
        </Flex>
        <Text color="gray.700" fontSize="lg">
          A calm place to track what matters this week — tasks, dates, and what to do next.
        </Text>
        <Stack direction={{ base: "column", sm: "row" }} spacing={3} w="100%">
          <Button as={RouterLink} to="/signup" colorScheme="teal" size="lg" w="100%">
            Create account
          </Button>
          <Button as={RouterLink} to="/login" variant="outline" size="lg" w="100%">
            Sign in
          </Button>
        </Stack>
        <Box fontSize="sm" color="gray.600">
          Using Grok or another assistant? After you sign up, open{" "}
          <Text as="span" fontWeight="semibold">
            Settings → API tokens
          </Text>{" "}
          and create a token for your bot.
        </Box>
        <Link as={RouterLink} to="/login" color="teal.600" fontSize="sm">
          Already have an account? Sign in
        </Link>
      </Stack>
    </Flex>
  );
}
